import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { BundleRoute } from '@saucelabs/sl-component-router';
import { RedirectToDjango } from '@saucelabs/sl-container-experiment';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';

import jobsReducer from './reducers';

const importJobsSubaccount = () => import(/* webpackChunkName: "jobs-subaccount" */ './containers/JobsSubaccountContainer');

const JobsSubaccountRoutes = ({ match }) => (
  <LoginRequiredContainer>
    <Switch>
      <BundleRoute
        load={importJobsSubaccount}
        path={`${match.url}/:username/dashboard/:tabName?/:cloudType?`}
      />
      {/* Redirect if there no Route match to switch to Django app */}
      <Route component={RedirectToDjango} />
    </Switch>
  </LoginRequiredContainer>
);

JobsSubaccountRoutes.propTypes = {
  match: PropTypes.object.isRequired,
};

export default dynamic(
  'apps.jobs', attachReducer(jobsReducer),
)(JobsSubaccountRoutes);
export { JobsSubaccountRoutes };
